import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BcaRequestModel} from './BcaRequest.model';
import {MandiriSyariahModel} from './mandiri-syariah-model';
import {DanamonModel} from './danamon-model';
import {AlfaModel} from './alfa-model';


@NgModule({
    providers: [
        CommonModule,
        BcaRequestModel,
        MandiriSyariahModel,
        DanamonModel,
        AlfaModel
    ]
})
export class ModelModule {
}
